<template>
  <div id="navSearch" class="gd-search" ref="searchWrap">
    <div class="gd-search__wrap" :class="{ search: show }">
      <div class="gd-search__btn-wrap" ref="wrap" :class="{ active: open }">
        <div @click="select(address, true)" class="gd-search__btn">
          <svg>
            <use xlink:href="#icon-search-light"></use>
          </svg>
          <p ref="address" :class="{ active: show }">Address</p>
        </div>
        <div @click="select(key, false)" class="gd-search__btn">
          <p ref="key" :class="{ active: !show }">Keyword</p>
          <svg>
            <use xlink:href="#icon-key-light"></use>
          </svg>
        </div>
        <div class="gd-search__line" ref="line"></div>
      </div>
      <div class="gd-search__forms-wrap">
        <div @click="open = !open" class="gd-search__select-wrap">
          <transition name="slide-fade" mode="out-in">
            <div v-if="show" class="gd-search__select">
              <svg>
                <use xlink:href="#icon-search-light"></use>
              </svg>
              <svg class="gd-search__arrow">
                <use xlink:href="#icon-caret-down-solid"></use>
              </svg>
            </div>
            <div v-else class="gd-search__select">
              <svg>
                <use xlink:href="#icon-key-light"></use>
              </svg>
              <svg class="gd-search__arrow">
                <use xlink:href="#icon-caret-down-solid"></use>
              </svg>
            </div>
          </transition>
        </div>
        <transition name="slide-fade" mode="out-in">
          <GetCategory v-if="show" key="1" />
          <NetoSearch v-else key="2" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import GetCategory from "./GetCategory.vue";
import NetoSearch from "../search-form/NetoSearch.vue";
import { type Ref, ref, onMounted } from "vue";

const show: Ref<boolean> = ref(true);
const open: Ref<boolean> = ref(false);
const address: Ref<HTMLElement | undefined> = ref();
const key: Ref<HTMLElement | undefined> = ref();
const line: Ref<HTMLElement | undefined> = ref();
const searchWrap: Ref<HTMLElement | undefined> = ref();
const wrap: Ref<HTMLElement | undefined> = ref();

function select(el: HTMLElement | undefined, isShown: boolean) {
  if (!el || !line.value || !wrap.value) return;
  show.value = isShown;
  open.value = false;
  line.value.style.width = el.offsetWidth + "px";
  line.value.style.left =
    el.getBoundingClientRect().left -
    wrap.value.getBoundingClientRect().left +
    "px";
}

function topFrom() {
  if (!searchWrap.value) return;
  window.addEventListener("scroll", () => {
    if (window.pageYOffset > 72) {
      searchWrap.value!.classList.add("top");
    } else {
      searchWrap.value!.classList.remove("top");
    }
  });
}

onMounted(() => {
  select(address.value, true);
  // topFrom();
});
</script>
